import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative pt-40 pb-28 lg:pb-40 overflow-hidden">
      {/* Decorative wave SVG on the right */}
      <div className="hero-decor absolute top-0 right-0 w-[60%] h-full hidden md:block">
        <svg viewBox="0 0 800 900" className="w-full h-full" preserveAspectRatio="xMaxYMid slice">
          <defs>
            <linearGradient id="waveGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#d4b896" stopOpacity="0.5" />
              <stop offset="100%" stopColor="#b89968" stopOpacity="0.15" />
            </linearGradient>
          </defs>
          {Array.from({ length: 70 }).map((_, i) => {
            const offset = i * 6;
            return (
              <path
                key={i}
                d={`M ${200 + offset * 0.3},0 
                    C ${300 + offset * 0.5},${200 + offset * 0.5} 
                      ${500 + offset * 0.2},${400 + offset * 0.3} 
                      ${350 + offset * 0.6},${600 + offset * 0.4} 
                    S ${250 + offset * 0.4},900 ${400 + offset * 0.7},950`}
                fill="none"
                stroke="url(#waveGrad)"
                strokeWidth="0.6"
                opacity={0.7 - i * 0.008}
              />
            );
          })}
        </svg>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-2xl fade-up">
          <div className="flex items-center gap-4 mb-10">
            <span className="w-10 h-px tinde-gold-bg"></span>
            <span className="text-[11px] tracking-[0.3em] tinde-gold uppercase">Elevating Healthcare</span>
          </div>

          <h1 className="font-serif text-[56px] md:text-[72px] lg:text-[88px] leading-[1.05] text-[#1a1a1a] font-normal">
            Better care.
            <br />
            Meaningful impact.
            <br />
            Lasting results.
          </h1>

          <p className="mt-10 text-[#5a5a5a] text-base md:text-lg leading-relaxed max-w-md">
            Transforming clinics through insight, strategy, and innovation.
          </p>

          <a
            href="#services"
            className="btn-dark group mt-12 inline-flex items-center gap-6 px-10 py-5 text-[11px] tracking-[0.3em] uppercase"
          >
            Discover Tinde
            <ArrowRight size={16} className="hover-arrow" />
          </a>
        </div>
      </div>
    </section>
  );
}
